import React from 'react'
import { Helmet } from 'react-helmet'
import NewsletterL1 from '../../../Componet/Newsletter/NewsletterL1'
import HerosectionHeader from '../../../Componet/Herosection/HerosectionHeader'
import Cons1 from '../../../Componet/Consulting/Cons1He'
import ConsultingForm from '../../../Componet/Consulting/ConsultingForm'

const MEETING_URL = 'https://meetings.hubspot.com/viacheslav-seifer'

function ConsultingHePage() {
    return (
        <div className="consulting-page-rtl" dir="rtl">
            <Helmet>
                <title>EpicFinal - ייעוץ וליווי טכנולוגי</title>
                <meta
                    name="description"
                    content="ייעוץ וליווי טכנולוגי לעסקים, סטארטאפים וארגונים שצריכים החלטות טכנולוגיות טובות יותר, מערכות יציבות יותר ותשתית נכונה לצמיחה."
                />
                <meta
                    name="keywords"
                    content="ייעוץ טכנולוגי, ליווי טכנולוגי, ארכיטקטורת תוכנה, תכנון מערכות, ייעוץ ענן, scaling, הנהגה טכנולוגית"
                />
                <meta property="og:title" content="EpicFinal - ייעוץ וליווי טכנולוגי" />
                <meta
                    property="og:description"
                    content="כיוון טכנולוגי ברור, תכנון מערכות ותשתיות, וליווי מעשי לעסקים שרוצים לגדול בצורה יציבה ומסודרת."
                />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://epicfinal.com/he/consulting" />
                <meta property="og:locale" content="he_IL" />
                <meta property="og:site_name" content="EpicFinal" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="EpicFinal - ייעוץ וליווי טכנולוגי" />
                <meta
                    name="twitter:description"
                    content="ייעוץ טכנולוגי פרקטי לעסקים שצריכים יציבות, כיוון ותשתית נכונה לצמיחה."
                />
            </Helmet>
            <HerosectionHeader folder1={"pages"} folder2={"Solutions"} name={"ייעוץ וליווי טכנולוגי"} />

            <div className="page-content">
                <Cons1 />
                <ConsultingForm
                    language="he"
                    formId="epic-consulting-form"
                    conversionSendTo="AW-11461100984/z1j0CK65tJgcELiLitkq"
                    requireHubspotCookie={true}
                    meetingUrl={MEETING_URL}
                    title="בואו נדבר על הצעד הבא"
                    subtitle="כמה פרטים קצרים על המצב הקיים, ואנחנו נחזור אליכם עם כיוון ראשוני ברור."
                />
                <NewsletterL1 />
            </div>
        </div>
    )
}

export default ConsultingHePage

